"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timer = void 0;
require("core-js/modules/web.timers.js");
var _Observable = require("./Observable");
var timer = exports.timer = function timer(interval) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
  return (0, _Observable.mkObservable)(function (observer) {
    var i = 0;
    var t = setInterval(function () {
      observer.next(i++);
      if (i === limit) {
        observer.complete();
        clearInterval(t);
      }
    }, interval);
    return function () {
      return clearInterval(t);
    };
  });
};